<template lang="pug">
	.preview
		v-e24-nav-bar
		project-preview(:proj-id="projId")
		v-e24-footer(:build="build")
</template>
<script>
import ProjectPreview from 'App/project/preview-component.vue'
import readBuild from '../../util/readBuild'

export default {
	name: 'app-project-preview',
	props: ['projId'],
	components: {
		ProjectPreview
	},
	data () {
		return {
			build: ''
		}
	},
	mixins: [readBuild],
	mounted () {
		this.build = this.getBuild()
	}
}
</script>



// WEBPACK FOOTER //
// src/app/project/preview.vue